<a href="https://app.focuspos.com/{{ ooVenue.venueKey }}">
	<div class="h-100">
		<div class="card h-100">
			<div class="p-grid">
				<div class="p-col">
					<img
						width="100%"
						height="auto"
						class="oo-venue-logo"
						[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + ooVenue.venueKey + '/logo.png'"
						onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'"
					/>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col-12 text-center">
					<div class="d-flex flex-column">
						<div class="display-12">
							{{ ooVenue.name }}
						</div>
						<div class="display-14">{{ ooVenue.address1 }}, {{ ooVenue.city }}, {{ ooVenue.state }} {{ ooVenue.zip }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</a>
